var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import http from '../request';
const defaultAuthParams = {
    url: '',
    client_id: '',
    client_secret: '',
    password_min: 6,
    password_max: 20,
    company: 0,
};
/** 一些参数的固定配置项 */
const AUTH_PARAMS = {
    appVersion: '1.0.0',
    scope: 'read',
    grant_type_password: 'password',
    grant_type_sms: 'sms',
    grant_type_face: 'face',
    register_type_phone: 'phone',
    register_type_password: 'password',
};
const getParams = () => {
    let authConfig = window.authConfig;
    try {
        if (!authConfig) {
            authConfig = defaultAuthParams;
        }
    }
    catch (error) { }
    return authConfig;
};
const validateAuthParams = (params) => {
    const { url, client_id, client_secret, password_min, password_max } = params;
    validateUrl(url);
    validateClient(client_id, client_secret);
    validatePassword(password_min, password_max);
};
const validateUrl = (url) => {
    if (!url) {
        throw {
            success: false,
            message: '您没有配置url参数',
        };
    }
};
const validateClient = (clientId, clientSecret) => {
    if (!clientId || !clientSecret) {
        throw {
            success: false,
            message: 'client相关参数配置有问题',
        };
    }
};
const validatePassword = (min, max) => {
    if (!min || !max) {
        throw {
            success: false,
            message: '配置中必须包含password_min和password_max参数',
        };
    }
};
const { appVersion, scope, grant_type_password, grant_type_sms, grant_type_face, register_type_phone, register_type_password, } = AUTH_PARAMS;
const authUtils = {
    getParams,
    validateAuthParams,
    /** 发送验证码时需要传入的type参数 */
    SMS_TYPE: {
        register: 0,
        changePassword: 1,
        login: 2,
    },
    /** 客户端类型 */
    CLIENT_TYPE: {
        app: 0,
        webPC: 1,
    },
    /**
     * 用户名+密码登录
     * @param username 用户名
     * @param password 密码
     */
    passwordLoginWithUsername(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/oauth/token`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    client_secret,
                    scope, grant_type: grant_type_password }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '登录失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 手机号+密码登录
     * @param phone 手机号
     * @param password 密码
     */
    passwordLoginWithPhone(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/oauth/token`, {
                    username: params.phone,
                    password: params.password,
                    appVersion,
                    client_id,
                    client_secret,
                    scope,
                    grant_type: grant_type_password,
                    usingPhonePassword: true,
                });
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '登录失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 人脸登录
     * @param face 人脸数据，图片base64编码
     * @param client 客户端类型，0-app;1-webPC
     * @param identification 设备识别号，app一般是设备号 webPC一般ip
     */
    faceLogin(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/oauth/token`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    client_secret,
                    scope, grant_type: grant_type_face }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '登录失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 手机号+验证码登录(登录即注册)
     * @param phone 手机号
     * @param code 验证码
     */
    smsLogin(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/users/smsLogin`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    client_secret,
                    scope, grant_type: grant_type_sms }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '登录失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 用户名+密码注册
     * @param username 用户名
     * @param password 密码
     */
    passwordRegister(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/users/register`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    client_secret,
                    scope, register_type: register_type_password }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '注册失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 手机号+验证码+密码注册
     * @param mobile 手机号
     * @param password 密码
     * @param verification_code 验证码
     */
    smsRegister(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, client_secret } = authParams;
                const response = yield http.authForm(`${url}/authz/users/register`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    client_secret,
                    scope, register_type: register_type_phone, smsType: 0 }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '注册失败，请重试',
                    code: error.code || 50000,
                    result: {
                        access_token: '',
                    },
                };
            }
        });
    },
    /**
     * 发送验证码
     * @param mobile 手机号
     * @param type 短信类型 0-注册 1-修改密码 2-绑定用户或者验证码登录
     */
    sendSmsCode(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id, company } = authParams;
                const response = yield http.authForm(`${url}/authz/sms/send`, Object.assign(Object.assign({}, params), { appVersion,
                    client_id,
                    company }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '发送失败，请重试',
                    code: error.code || 50000,
                };
            }
        });
    },
    /**
     * 重置密码-短信方式
     * @param phone 手机号
     * @param newPassword 新密码
     * @param verificationCode 验证码
     */
    resetPassword(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url, client_id } = authParams;
                const response = yield http.authForm(`${url}/authz/users/resetPassword`, Object.assign(Object.assign({}, params), { client_id: client_id, appVersion }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '操作失败，请重试',
                    code: error.code || 50000,
                };
            }
        });
    },
    /**
     * 修改密码
     * @param access_token token
     * @param newPassword 新密码
     * @param oldPassword 旧密码
     */
    updatePassword(params, authParams = getParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                validateAuthParams(authParams);
                const { url } = authParams;
                const response = yield http.authForm(`${url}/resource/user/updatePassword`, Object.assign(Object.assign({}, params), { appVersion }));
                return response;
            }
            catch (error) {
                throw {
                    success: false,
                    message: error.msg || '操作失败，请重试',
                    code: error.code || 50000,
                };
            }
        });
    },
};
export default authUtils;
